import VueRouter from 'vue-router';
import UserActivitiesManager from 'fourwaves-shared/src/services/user-activities/manager';
import { BaseApiService } from 'fourwaves-shared/src/services/fourwaves/baseApiService';

type NuxtAppWithUserActivitiesManager = {
  app: {
    $activities: UserActivitiesManager;
    $api: BaseApiService;
    router: VueRouter;
    store: any;
  };
};

export default ({ app }: NuxtAppWithUserActivitiesManager, inject) => {
  inject('activities', new UserActivitiesManager(app.$api, 'event_website'));

  // Track page views. If a user clicks reload after reaching the page, this is counted as an additional pageview.
  // We could determine unique page views using the sessionId.
  app.router.afterEach((to, from) => {
    let path = to.path.replace(`/${to.params.slug}`, '');

    // treat '/pages' and '/pages/' as the home page
    if (path === '/pages' || path === '/pages/') path = '/';
    if (path === '/fr/pages' || path === '/fr/pages/') path = '/fr';

    // do not process lang redirects
    if (to.name?.split('___')[0] === from.name?.split('___')[0]) return;

    // do not process redirections
    if (path === '/redirection') return;

    if (path) {
      const eventId = app.store.state.events.currentEvent?.id;
      if (eventId) {
        app.$activities.send('page.view', { eventId, reference: path });
      }
    }
  });
};
